import { React } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
// import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { lazy } from "react";



const AdminLayout = lazy(
  () => import("layouts/admin")
);

function PrivateRoute({ children }) {
  const auth = localStorage.getItem('token')
  return auth ? children : <Navigate to="/auth/sign-in" />;
}

const App = () => {
  
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route
          path="admin/*"
          element={
            <PrivateRoute>
              <AdminLayout/>
            </PrivateRoute>
          }
        />
      <Route path="/" element={<Navigate to="/admin/" replace />} />
      <Route path="/*" element={<Navigate to="/auth/not-found" replace />} />

    </Routes>

  );
};

export default App;
